import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CyberRisksItemBlockData from 'app/Models/Content/CyberRisksItemBlockData';
import CyberRisksItemsBlockData from 'app/Models/Content/CyberRisksItemsBlockData';
import MarketingTextBlockData from 'app/Models/Content/MarketingTextBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import React from 'react';
import {Container} from 'reactstrap';
import {getImageProps} from 'app/utilities/ImageProps';

const CyberRisksItemsBlock = ({data, context}: ComponentProps<CyberRisksItemsBlockData>) => {
  return (
<div className='CyberRisksItemsBlock' style={{ paddingBottom: '80px !important' }}>
        <h2 className='CyberRisksItemsBlock__title'>{data.title.value}</h2>
      <p className='CyberRisksItemsBlock__subtitle'>{data.subtitle.value}</p>

      <Container className='CyberRisksItemsBlock__items'>
        <div className='CyberRisksItemsBlock__items__wraper'>
          {data.items.expandedValue.map((item: CyberRisksItemBlockData, i) => (
            <div className='CyberRisksItemsBlock__items__wraper__image-and-details'>
              <Image {...getImageProps(item.titleAsImage, context)} />

              <div className='CyberRisksItemsBlock__items__wraper__image-and-details__title-and-description'>
                {item.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
                  <h3 key={i}>{getTextWithHighlight({text: text.value, highlightText: highlightText.value})}</h3>
                ))}

                <p className='CyberRisksItemsBlock__items__wraper__image-and-details__title-and-description__description'>
                  {item.description.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default CyberRisksItemsBlock;
